export default "__VITE_ASSET__CBt_SZ_$__"